import React, { useEffect, lazy, Suspense } from "react";
import "./App.css";

import { Outlet, BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSelector } from "react-redux";
import ProtectedRoute from "./components/ProtectedRoute";
import OTPVerification from "./pages/Auth/OTPVerification";
import Dashboard from "./pages/Dashboard";
import CustomerManagement from "./pages/CustomerManagement/CustomerManagement";
import ViewCustomer from "./pages/CustomerManagement/ViewCustomer";
import ViewOrder from "./pages/OrderManagement/ViewOrder";
import MenuAndRestaurantManagement from "./pages/MenuAndRestaurantManagement/MenuAndRestaurantManagement";
import DishApproval from "./pages/DishApproval/DishApproval";
import ViewDishApproval from "./pages/DishApproval/ViewDishApproval";
import ViewMenuCatalogue from "./pages/MenuAndRestaurantManagement/RestaurantList/ViewMenuCatalogue";
import ItemsDetails from "./pages/MenuAndRestaurantManagement/RestaurantList/ItemDetails";
import ViewRestaurant from "./pages/MenuAndRestaurantManagement/RestaurantList/ViewRestaurant";
import RestaurantWalletLedger from "./pages/MenuAndRestaurantManagement/RestaurantList/RestaurantWalletLedger";
import Reviews from "./pages/MenuAndRestaurantManagement/RestaurantList/Reviews";
import RestaurantPayoutList from "./pages/MenuAndRestaurantManagement/RestaurantList/RestaurantPayoutList";
import CallDetail from "./pages/MenuAndRestaurantManagement/RestaurantList/CallDetail";
import SubscriptionDetails from "./pages/MenuAndRestaurantManagement/RestaurantList/SubscriptionDetails";
import ManagePincode from "./pages/MenuAndRestaurantManagement/RestaurantList/ManagePincode";
import ViewRestaurantRegistration from "./pages/MenuAndRestaurantManagement/PendingRestaurant/ViewRestaurantRegistration";
import DriverManagment from "./pages/DriverManagment/DriverManagment";
import ViewDriver from "./pages/DriverManagment/ViewDriver";
import DriverWalletLedger from "./pages/DriverManagment/DriverWalletLedger";
import OrderManagement from "./pages/OrderManagement/OrderManagement";
import TransactionManagement from "./pages/TransactionManagement/TransactionManagement";
import SubscriptionView from "./pages/TransactionManagement/SubscriptionView";
import PayoutManagement from "./pages/PayoutManagement/PayoutManagement";
import ScheduledPayouts from "./pages/PayoutManagement/ScheduledPayouts";
import ScheduledPayoutRestaurants from "./pages/PayoutManagement/ScheduledPayoutRestaurants";
import ScheduledPayoutTransactionDetail from "./pages/PayoutManagement/ScheduledPayoutTransactionDetail";
import AdminWallet from "./pages/PayoutManagement/AdminWallet";
import PayoutCrDrNotes from "./pages/PayoutManagement/PayoutCrDrNotes";
import PayoutCrDrNoteDetail from "./pages/PayoutManagement/PayoutCrDrNoteDetail";
import PayoutManagementDriver from "./pages/PayoutManagement/Restaurant/PayoutManagementDriver";
import PayoutManagementDriverView from "./pages/PayoutManagement/Restaurant/PayoutManagementDriverView";
import SalesAndPerformanceReport from "./pages/SalesAndPerformanceReport/SalesAndPerformanceReport";
import ContentManagementSystem from "./pages/ContentManagementSystem/ContentManagementSystem";
import GlobalParameter from "./pages/GlobalParameter/GlobalParameter";
import ReviewAndRatingManagement from "./pages/ReviewAndRatingManagement/ReviewAndRatingManagement";
import BannerManagement from "./pages/BannerManagement/BannerManagement";
import Notification from "./pages/Notification/Notification";
import CuisineList from "./pages/CuisineList/CuisineList";
import AddCuisine from "./pages/CuisineList/AddCuisine";
import UpdateCuisine from "./pages/CuisineList/UpdateCuisine";
import DishCategories from "./pages/DishCategories/DishCategories";
import AddDish from "./pages/DishCategories/AddDish";
import UpdateDish from "./pages/DishCategories/UpdateDish";
import Ingrident from "./pages/Ingrident/Ingrident";
import AddIngrident from "./pages/Ingrident/AddIngrident";
import UpdateIngrident from "./pages/Ingrident/UpdateIngrident";
import MealType from "./pages/MealType/MealType";
import AddMealType from "./pages/MealType/AddMealType";
import UpdateMealType from "./pages/MealType/UpdateMealType";
import Alergies from "./pages/Alergies/Alergies";
import AddAllergenItem from "./pages/Alergies/AddAllergenItem";
import UpdateAllergy from "./pages/Alergies/UpdateAllergy";
import ManagePincodes from "./pages/ManagePincode/ManagePincode";
import Subscription from "./pages/Subscription/Subscription";
import AddSubscription from "./pages/Subscription/AddSubscription";
import ViewSubscription from "./pages/Subscription/ViewSubscription";
import AddNotification from "./pages/Notification/AddNotification";
import AddDriver from "./pages/DriverManagment/AddDriver";
import Variations from "./pages/variations/variationList";
import AddVariation from "./pages/variations/addVariation";
import UpdateVariation from "./pages/variations/updateVariation"
import UsersNotification from "./pages/Notification/notificationUser";
import AdminCsvSocketListener from "./components/AdminCsvSocketListener";
import AdminProfile from "./pages/Profile/AdminProfile";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const mainPanel = document.querySelector(".page-body-wrapper .main-panel");
    if (mainPanel) {
      mainPanel.scrollTop = 0;
    }
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

const Login = lazy(() => import("../src/pages/Auth/Login"));
const ForgotPassword = lazy(() => import("../src/pages/Auth/ForgotPassword"));
const ResetPassword = lazy(() => import("../src/pages/Auth/ResetPassword"));
const AddBanner = lazy(() => import("./pages/BannerManagement/AddBanner"));
const UpdateBanner = lazy(() => import("./pages/BannerManagement/UpdateBanner"));
const EditBanner = lazy(() => import("./pages/BannerManagement/EditBanner"));
function App() {
  return (
    <>
      <ToastContainer
        position={"top-right"}
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        style={{ zIndex: 100000 }}
      />
      <Router>
        <ScrollToTop />
        <AdminCsvSocketListener />
        <Suspense fallback="Loading....">
          <Routes>
            {/* Public Routes */}
            <Route exact path="" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/otp-verification" element={<OTPVerification />} />

            {/* Protected Routes */}
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <AdminProfile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/customer-management"
              element={
                <ProtectedRoute>
                  <CustomerManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/view-customer/:id"
              element={
                <ProtectedRoute>
                  <ViewCustomer />
                </ProtectedRoute>
              }
            />
            <Route
              path="/view-order/:id"
              element={
                <ProtectedRoute>
                  <ViewOrder />
                </ProtectedRoute>
              }
            />
            <Route
              path="/menu-and-restaurant-management"
              element={
                <ProtectedRoute>
                  <MenuAndRestaurantManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dish-approval"
              element={
                <ProtectedRoute>
                  <DishApproval />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dish-approval/view/:id"
              element={
                <ProtectedRoute>
                  <ViewDishApproval />
                </ProtectedRoute>
              }
            />
            <Route
              path="/menu-and-restaurant/view-menu-catalogue/:id/:name"
              element={
                <ProtectedRoute>
                  <ViewMenuCatalogue />
                </ProtectedRoute>
              }
            />
            <Route
              path="/menu-and-restaurant/view-menu-catalogue/item-details/:id"
              element={
                <ProtectedRoute>
                  <ItemsDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/menu-and-restaurant/view-restaurant/:id/wallet-ledger"
              element={
                <ProtectedRoute>
                  <RestaurantWalletLedger />
                </ProtectedRoute>
              }
            />
            <Route
              path="/menu-and-restaurant/view-restaurant/:id"
              element={
                <ProtectedRoute>
                  <ViewRestaurant />
                </ProtectedRoute>
              }
            />
            <Route
              path="/menu-and-restaurant/view-restaurant/reviews"
              element={
                <ProtectedRoute>
                  <Reviews />
                </ProtectedRoute>
              }
            />
            <Route
              path="/menu-and-restaurant/view-order/:id"
              element={
                <ProtectedRoute>
                  <ViewOrder />
                </ProtectedRoute>
              }
            />
            <Route
              path="/menu-and-restaurant/view-driver/:id"
              element={
                <ProtectedRoute>
                  <ViewDriver />
                </ProtectedRoute>
              }
            />
            <Route
              path="/menu-and-restaurant/view-restaurant/restaurant-payout-list"
              element={
                <ProtectedRoute>
                  <RestaurantPayoutList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/menu-and-restaurant/view-restaurant/call-detail"
              element={
                <ProtectedRoute>
                  <CallDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/menu-and-restaurant/view-restaurant/subscription-details/:id"
              element={
                <ProtectedRoute>
                  <SubscriptionDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/menu-and-restaurant/view-restaurant/manage-pincode"
              element={
                <ProtectedRoute>
                  <ManagePincode />
                </ProtectedRoute>
              }
            />
            <Route
              path="/menu-and-restaurant/pending-restaurant/view-restaurant-registration"
              element={
                <ProtectedRoute>
                  <ViewRestaurantRegistration />
                </ProtectedRoute>
              }
            />
            <Route
              path="/driver-managment"
              element={
                <ProtectedRoute>
                  <DriverManagment />
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-driver"
              element={
                <ProtectedRoute>
                  <AddDriver />
                </ProtectedRoute>
              }
            />
            <Route
              path="/driver-managment/view-driver/:id/wallet-ledger"
              element={
                <ProtectedRoute>
                  <DriverWalletLedger />
                </ProtectedRoute>
              }
            />
            <Route
              path="/driver-managment/view-driver/:id"
              element={
                <ProtectedRoute>
                  <ViewDriver />
                </ProtectedRoute>
              }
            />
            <Route
              path="/order-management"
              element={
                <ProtectedRoute>
                  <OrderManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/transaction-management"
              element={
                <ProtectedRoute>
                  <TransactionManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/transaction-management/subscription-view/:id"
              element={
                <ProtectedRoute>
                  <SubscriptionView />
                </ProtectedRoute>
              }
            />
            <Route
              path="/payout-management"
              element={
                <ProtectedRoute>
                  <PayoutManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/payout-management/scheduled-payouts"
              element={
                <ProtectedRoute>
                  <ScheduledPayouts />
                </ProtectedRoute>
              }
            />
            <Route
              path="/payout-management/admin-wallet"
              element={
                <ProtectedRoute>
                  <AdminWallet />
                </ProtectedRoute>
              }
            />
            <Route
              path="/payout-management/credit-debit"
              element={
                <ProtectedRoute>
                  <PayoutCrDrNotes />
                </ProtectedRoute>
              }
            />
            <Route
              path="/payout-management/credit-debit/:id"
              element={
                <ProtectedRoute>
                  <PayoutCrDrNoteDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/payout-management/scheduled-payouts/:payoutId/transaction/:transactionId"
              element={
                <ProtectedRoute>
                  <ScheduledPayoutTransactionDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/payout-management/scheduled-payouts/:payoutId"
              element={
                <ProtectedRoute>
                  <ScheduledPayoutRestaurants />
                </ProtectedRoute>
              }
            />
            <Route
              path="/payout-management/driver"
              element={
                <ProtectedRoute>
                  <PayoutManagementDriver />
                </ProtectedRoute>
              }
            />
            <Route
              path="/payout-management/driver/view"
              element={
                <ProtectedRoute>
                  <PayoutManagementDriverView />
                </ProtectedRoute>
              }
            />
            <Route
              path="/sales-and-performance-report"
              element={
                <ProtectedRoute>
                  <SalesAndPerformanceReport />
                </ProtectedRoute>
              }
            />
            <Route
              path="/global-parameter"
              element={
                <ProtectedRoute>
                  <GlobalParameter />
                </ProtectedRoute>
              }
            />
            <Route
              path="/review-and-rating-management"
              element={
                <ProtectedRoute>
                  <ReviewAndRatingManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/banner-management"
              element={
                <ProtectedRoute>
                  <BannerManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-banner"
              element={
                <ProtectedRoute>
                  <AddBanner />
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit-banner/:id"
              element={
                <ProtectedRoute>
                  <UpdateBanner />
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit-banner"
              element={
                <ProtectedRoute>
                  <EditBanner />
                </ProtectedRoute>
              }
            />
            <Route
              path="/content-management-system"
              element={
                <ProtectedRoute>
                  <ContentManagementSystem />
                </ProtectedRoute>
              }
            />
            <Route
              path="/notification"
              element={
                <ProtectedRoute>
                  <Notification />
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-notification"
              element={
                <ProtectedRoute>
                  <AddNotification />
                </ProtectedRoute>
              }
            />
            {/* UsersNotification */}
            <Route
              path="/notification-receivers"
              element={
                <ProtectedRoute>
                  <UsersNotification />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cuisine-list"
              element={
                <ProtectedRoute>
                  <CuisineList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cuisine-list/add-cuisine"
              element={
                <ProtectedRoute>
                  <AddCuisine />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cuisine-list/edit-cuisine/:id"
              element={
                <ProtectedRoute>
                  <UpdateCuisine />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dish-categories"
              element={
                <ProtectedRoute>
                  <DishCategories />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dish-categories/add-dish"
              element={
                <ProtectedRoute>
                  <AddDish />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dish-categories/edit-dish/:id"
              element={
                <ProtectedRoute>
                  <UpdateDish />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ingrident"
              element={
                <ProtectedRoute>
                  <Ingrident />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ingrident/add-ingrident"
              element={
                <ProtectedRoute>
                  <AddIngrident />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ingrident/edit-ingrident/:id"
              element={
                <ProtectedRoute>
                  <UpdateIngrident />
                </ProtectedRoute>
              }
            />
            <Route
              path="/meal-type"
              element={
                <ProtectedRoute>
                  <MealType />
                </ProtectedRoute>
              }
            />
            <Route
              path="/meal-type/add-meal"
              element={
                <ProtectedRoute>
                  <AddMealType />
                </ProtectedRoute>
              }
            />
            <Route
              path="/meal-type/edit-meal/:id"
              element={
                <ProtectedRoute>
                  <UpdateMealType />
                </ProtectedRoute>
              }
            />
            <Route
              path="/alergies"
              element={
                <ProtectedRoute>
                  <Alergies />
                </ProtectedRoute>
              }
            />
            <Route
              path="/alergies/add-allergen-item"
              element={
                <ProtectedRoute>
                  <AddAllergenItem />
                </ProtectedRoute>
              }
            />
            <Route
              path="/alergies/edit-allergy/:id"
              element={
                <ProtectedRoute>
                  <UpdateAllergy />
                </ProtectedRoute>
              }
            />
            <Route
              path="/variations"
              element={
                <ProtectedRoute>
                  <Variations />
                </ProtectedRoute>
              }
            />
            <Route
              path="/variation/add-variation"
              element={
                <ProtectedRoute>
                  <AddVariation />
                </ProtectedRoute>
              }
            />
            <Route
              path="/variation/edit-variation/:id"
              element={
                <ProtectedRoute>
                  <UpdateVariation />
                </ProtectedRoute>
              }
            />
            <Route
              path="/manage-pincodes"
              element={
                <ProtectedRoute>
                  <ManagePincodes />
                </ProtectedRoute>
              }
            />
            <Route
              path="/subscription"
              element={
                <ProtectedRoute>
                  <Subscription />
                </ProtectedRoute>
              }
            />
            <Route
              path="/subscription/add-subscription"
              element={
                <ProtectedRoute>
                  <AddSubscription />
                </ProtectedRoute>
              }
            />
            <Route
              path="/subscription/view-subscription"
              element={
                <ProtectedRoute>
                  <ViewSubscription />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Suspense>
      </Router>
    </>
  );
}

export default App;
